export const sliceKey = 'instoreService';

export const isPoshivShtor = (categoryId: string) => categoryId === '2136';
